import { UnitStateData } from '@mark43/cad-api';
import { ButtonGroup, ModalFooter, Button } from '@cad-arc';
import { ModalControls } from './types';

interface IncomingAssignmentModalFooterParams {
    alternateEnRouteState?: UnitStateData;
    alternateEnRouteStateMutation: () => void;
    enRouteState?: UnitStateData;
    enRouteStateMutation: () => void;
    mutationIsLoading?: boolean;
    modalControls: ModalControls;
}

export function IncomingAssignmentModalFooter({
    alternateEnRouteState,
    alternateEnRouteStateMutation,
    enRouteState,
    enRouteStateMutation,
    mutationIsLoading,
    modalControls,
}: IncomingAssignmentModalFooterParams): React.ReactElement {
    const shouldAutoFocusEnRoute = !!enRouteState;
    const shouldAutoFocusAlternateEnRoute = !shouldAutoFocusEnRoute && !!alternateEnRouteState;

    return (
        <ModalFooter>
            <ButtonGroup>
                {!!alternateEnRouteState && (
                    <Button
                        variant="outline"
                        isLoading={mutationIsLoading}
                        onClick={() => {
                            alternateEnRouteStateMutation();
                            modalControls.close();
                        }}
                        autoFocus={shouldAutoFocusAlternateEnRoute}
                    >
                        {alternateEnRouteState.value}
                    </Button>
                )}
                {!!enRouteState && (
                    <Button
                        variant="solid"
                        isLoading={mutationIsLoading}
                        onClick={() => {
                            enRouteStateMutation();
                            modalControls.close();
                        }}
                        autoFocus={shouldAutoFocusEnRoute}
                    >
                        {enRouteState.value}
                    </Button>
                )}
            </ButtonGroup>
        </ModalFooter>
    );
}
